// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__TzGcu","prev":"Pagination_prev__KOTtT","next":"Pagination_next__z29nK"};